/**
 * jv.Common.EmployeeSelect Module
 * ===============================
 *
 * Render a select2 widget for selecting employees. Optionally toggle multiple.
 * Added an option to allow entering the email in the select2 along with the employee data
 *
 * Usage in HTML
 * -------------
 * ```
 * <input jv-employee-select[="multiple"] [jv-employee-select-obj] [jv-employee-select-email] [jv-employee-select-disable-preselected] [jv-employee-select-filter=fn] data-placeholder="Select Recipients" ng-model="scheduleData.recipients" />
 * ```
 *
 * Add `jv-employee-select-obj` if you want the model to contain the data object instead of the id.
 *
 * Add `jv-employee-select-email` if you want to allow the email to be entered too. (Right now it will work only for multi select2.)
 *
 * Add `jv-employee-select-disable-preselected` to disable the removal of previously selected employees.
 *
 * Add `jv-employee-select-filter` to provide a function that filters the results using jQuery.map.
 *
 * Add `jv-employee-select-allow-clear` to show the clear button (only relevant when a placeholder is specified and not multi).
 *
 * Add 'jv-employee-select-token-separator' to provide token separators that needs to be tokenize. If none is specified, default([",",""]) will be used.
 *
 * Add 'jv-employee-select-enable-search-choice' if the searched email address has to be created as default choice and prepend it to the result list.
 *
 * Add 'jv-employee-select-image' if you want the items design to include the profile picture.
 *
 * Add 'jv-employee-select-exclude-email' if you want to exclude email and just show full name.
 *
 * Add 'jv-employee-select-page-size' to specify page size.
 *
 * Multiple URL's can be set per page / module
 * -------------------------------------------
 * Add `jv-employee-select-url` if you want to allow the employee select URL to be overridden.
 *
 * Usage in a module (one URL per module)
 * --------------------------------------
 * angular.module('moduleNameHere', []).value('url', '../action/user/search?roleName=Recruiter')
 *
 * If neither the `jv-employee-select-url` nor the `.value('url', '')` value is set, it will default to the one provided below.
 */
angular.module('jv.Common.EmployeeSelect', ['jv.Common.TextUtil'])

.config(['$provide', function($provide) {

    $provide.value('url', jvUrls.admin+'/action/user/search?');

}])

.directive('jvEmployeeSelect', ['$timeout', 'url', 'TextUtil', function($timeout, url, TextUtil){
    return {
        require: 'ngModel',
        link: function($scope, iElm, iAttrs, controller) {
            var params = '', // not sure what this is for
                filter = $scope.$eval(iAttrs.jvEmployeeSelectFilter),
                isMultiple = (iAttrs.jvEmployeeSelect === 'multiple'),
                employeeUrl = iAttrs.jvEmployeeSelectUrl || url,
                excludeEmail = iAttrs.jvEmployeeSelectExcludeEmail || false,
                pageSize = iAttrs.jvEmployeeSelectPageSize || 50,
                changed = false;

            var config = $.extend({},{
                id:'EId',
                multiple: isMultiple,
                allowClear: angular.isDefined(iAttrs.jvEmployeeSelectAllowClear),
                containerCssClass: (typeof iAttrs.jvEmployeeSelectImage !== 'undefined' && !iAttrs.jvEmployeeSelectImage) ? 'enhanced-select2' : '',
                dropdownCssClass: (typeof iAttrs.jvEmployeeSelectImage !== 'undefined' && !iAttrs.jvEmployeeSelectImage) ? 'enhanced-select2' : '',
                ajax: {
                    quietMillis: 500,
                    url: function() {
                        return iAttrs.jvEmployeeSelectUrl || url;
                    },
                    data: function (term, page) {
                        pageSize = term && 10 || pageSize;
                        var result = {
                                q: term,
                                action: 'getEmployees',
                                pageSize: pageSize,
                                page: page - 1,
                                fetchMaxSize: true
                            };
                        if(angular.isFunction(params)){
                            angular.extend(result, params());
                        }else if(angular.isObject(params)){
                            angular.extend(result, params);
                        }

                        return result;
                    },
                    results: function (data, page) { // parse the results into the format expected by Select2 .
                        // since we are using custom formatting functions we do not need to alter remote JSON data
                        var employees = data.employees || [],
                            more = Boolean(data.employeesCount > (pageSize * page));

                        if (angular.isFunction(filter)) {
                            employees = $.map(employees, filter);
                        }

                        return {
                            results: employees,
                            more: more
                        };
                    }
                },
                escapeMarkup: function(markup) {
                    return markup;
                },
                formatResult: function (employee) {
                    var defaultFormat = '<strong>' + TextUtil.htmlEncode(employee.fullName) + '</strong> ' + TextUtil.htmlEncode(employee.email),
                        imageFormat = '<img src=' + employee.userProfilePhotoUrl + ' class="img-circle">' + '<span><strong>' + TextUtil.htmlEncode(employee.fullName) + '</strong></span><br />' + TextUtil.htmlEncode(employee.email);
                    if(excludeEmail) {
                        defaultFormat =   TextUtil.htmlEncode(employee.fullName);
                    }

                    if (typeof iAttrs.jvEmployeeSelectImage !== 'undefined' && !iAttrs.jvEmployeeSelectImage) {
                        return imageFormat;
                    } else {
                        return defaultFormat;
                    }
                },
                formatSelection: function (employee) {
                    var defaultFormat = TextUtil.htmlEncode(employee.fullName),
                        imageFormat = '<img src=' + employee.userProfilePhotoUrl + ' class="img-circle">' + '<span>' + TextUtil.htmlEncode(employee.fullName) + '</span>';
                    if(excludeEmail) {
                        defaultFormat =   TextUtil.htmlEncode(employee.fullName);
                    }
                    if (typeof iAttrs.jvEmployeeSelectImage !== 'undefined' && !iAttrs.jvEmployeeSelectImage) {
                        return imageFormat;
                    } else {
                        return defaultFormat;
                    }
                },
                initSelection: function(element, callback) {
                    var query, model;
                    if (iAttrs.jvEmployeeSelectObj !== undefined && iAttrs.jvEmployeeSelectObj !== false) {
                        if (typeof iAttrs.jvEmployeeSelectDetailed !== 'undefined' && !iAttrs.jvEmployeeSelectDetailed) {
                            model = $scope.$eval(iAttrs.ngModel).employees;
                        } else {
                            model = $scope.$eval(iAttrs.ngModel);
                        }
                        if (angular.isObject(model)) {
                            return callback(model);
                        }
                    }
                    if (isMultiple) {
                        query = 'ids=' + element.val().split(',').join('&ids=');
                    }
                    else {
                        query = 'ids=' + element.val();
                    }
                    $.ajax({ method: 'GET', cache: false, url: employeeUrl + query, success: function(data){
                        data = config.ajax.results(data).results;
                        if(iAttrs.jvEmployeeSelectDisablePreselected !== undefined){
                            // add lock to the data.
                            angular.forEach(data, function(value, index){
                                value.locked = true;
                                data[index]= value;
                            });
                        }
                        if (!isMultiple) {
                            if (data.length) {
                                data = data[0];
                            }
                            else {
                                data = false;
                            }
                        }
                        callback(data);
                    }});
                }
            }, window._jvPluginDefaults.select2);

            // allow arbitrary email addresses to be entered
            if(iAttrs.jvEmployeeSelectEmail !== undefined && iAttrs.jvEmployeeSelect === 'multiple'){
                config.tags = true;
                config.tokenSeparators = angular.isDefined(iAttrs.jvEmployeeSelectTokenSeparator) ? [iAttrs.jvEmployeeSelectTokenSeparator] : [",", " "];
                if(iAttrs.jvEmployeeSelectEnableSearchChoice){
                    config.createSearchChoice = function(term, data) {
                    var emailPattern = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    if(emailPattern.test(term)){
                        return {
                            EId: term,
                            companyEId: term,
                            firstName:term,
                            email:"",
                            fullName: term
                        };
                    }
                };
                }
                config.formatNoMatches = function() {
                    return window._jvPluginDefaults && window._jvPluginDefaults.select2.formatEmployeeNoMatchText();
                };
            }

            iElm.select2(config).on('change', function(e) {
                changed = true;
                $scope.$apply(function() {
                    var val = e.val;
                    if (iAttrs.jvEmployeeSelectObj !== undefined && !iAttrs.jvEmployeeSelectObj !== false) {
                        if (typeof iAttrs.jvEmployeeSelectDetailed !== 'undefined' && !iAttrs.jvEmployeeSelectDetailed) {
                            val = {
                                employees: iElm.select2('data'),
                                added: e.added || null,
                                removed: e.removed || null
                            };
                        } else {
                            val = iElm.select2('data');
                        }
                    }
                    controller.$setViewValue(val);
                });
            });

            $scope.$watch(iAttrs.ngModel, function(employees) {
                if (typeof iAttrs.jvEmployeeSelectDetailed !== 'undefined' && !iAttrs.jvEmployeeSelectDetailed) {
                    if (!changed && ((isMultiple && employees.employees && employees.employees.constructor === Array && employees.employees.length > 0) || (!isMultiple && employees.employees)) ) {
                        iElm.select2('val', employees.employees);
                    }
                    if (!employees.employees || employees.employees.length === 0) {
                        iElm.select2('val', '');
                    }
                } else {
                    if (!changed && ((isMultiple && employees && employees.constructor === Array && employees.length > 0) || (!isMultiple && employees)) ) {
                        iElm.select2('val', employees);
                    }
                    if (!employees || employees.length === 0) {
                        iElm.select2('val', '');
                    }
                }
                changed = false;
            });

            $scope.$on('$destroy', function() {
                iElm.select2('destroy');
            });
        }
    };
}]);
